import type React from "react";

export function PredictionLoadingState({
  children,
}: {
  children: React.ReactNode;
}) {
  return <p className="text-r8-gray-11">{children}</p>;
}
